@if (showFooter && !isPageLoading()) {
  <div class="footer">
    <div class="footer-content">
      <div class="footer-content-top">
        <section class="left-side">
          <img alt="Gas South 20 Years Logo" [src]="pageLabels.gsLogo" />
          <p [innerHTML]="pageLabels.footerHeader"></p>
          <div class="link-container">
            @for (contactLink of pageLabels.contactInfoLinks; track $index) {
              @if (!contactLink.telephoneNumber) {
                <a [innerHTML]="contactLink.label" [href]="contactLink.link"></a>
                <p class="contact-link-description" [innerHTML]="contactLink.description"></p>
              }
            }
            @if (showTelephone) {
              @if (accountDetail.CustomerClass !== "LRGCOM") {
                <a [href]="pageLabels.telephoneLinkRes.link" [innerHTML]="pageLabels.telephoneLinkRes.label"></a>
                <p class="contact-link-description" [innerHTML]="pageLabels.telephoneLinkRes.description"></p>
              } @else {
                <a [href]="pageLabels.telephoneLinkLrg.link" [innerHTML]="pageLabels.telephoneLinkLrg.label"></a>
                <p class="contact-link-description" [innerHTML]="pageLabels.telephoneLinkLrg.description"></p>
              }
            }
          </div>
          <p class="hours-description" [innerHTML]="pageLabels.hoursOfOperation"></p>
          <div class="app-store-icons-container">
            <a class="apple-icon" [href]="pageLabels.appleStoreUrl">
              <img [src]="pageLabels.appleStoreImage" [alt]="pageLabels.appleImageAlt" />
            </a>
            <a class="android-icon" [href]="pageLabels.androidStoreUrl">
              <img [src]="pageLabels.androidStoreImage" [alt]="pageLabels.androidImageAlt" />
            </a>
          </div>
        </section>
        <section class="right-side">
          @if (isMobile) {
            <mat-accordion class="footer-mobile-accordion">
              @for (category of pageLabels.category; track $index) {
                <mat-expansion-panel>
                  <mat-expansion-panel-header class="category-header-container-mobile">
                    <mat-panel-title
                      class="category-header"
                      [innerHTML]="category.data.name | uppercase"
                    ></mat-panel-title>
                  </mat-expansion-panel-header>
                  @for (link of category.links; track $index) {
                    <mat-panel-description>
                      <a [innerHTML]="link.data.linkText" [href]="link.data.link" target="_blank"></a>
                    </mat-panel-description>
                  }
                </mat-expansion-panel>
              }
            </mat-accordion>
          } @else {
            <div class="footer-links-container">
              @for (category of pageLabels.category; track $index) {
                <div class="category-container">
                  <div class="category-header-container">
                    <div class="category-header" [innerHTML]="category.data.name | uppercase"></div>
                    <mat-divider class="header-hr-divider"></mat-divider>
                  </div>
                  @for (link of category.links; track $index) {
                    <a [innerHTML]="link.data.linkText" [href]="link.data.link" target="_blank"></a>
                  }
                </div>
              }
            </div>
          }
        </section>
      </div>
      <mat-divider class="hr-divider"></mat-divider>
      <div class="footer-content-bottom">
        <div class="social-media-icons-container">
          @for (icon of pageLabels.socialMediaIcons; track $index) {
            @if (icon.isImage) {
              <a class="social-media-icon-image" [href]="icon.url">
                <img [src]="icon.iconImage" [alt]="icon.iconAltText" />
              </a>
            } @else {
              <a
                class="social-media-icon"
                [href]="icon.url"
                [innerHTML]="icon.icon"
                [attr.aria-label]="icon.iconAriaLabel"
              ></a>
            }
          }
        </div>
        <p class="copy-right-text" [innerHTML]="pageLabels.copyRightText"></p>
        <div class="footer-bottom-links">
          <a
            class="terms-link"
            [href]="env.websiteBaseUrl + pageLabels.termLink.url"
            [innerHTML]="pageLabels.termLink.linkText"
            [attr.aria-label]="pageLabels.termLink.ariaLabel"
            target="_blank"
          ></a>
          <mat-divider class="vr-divider" [vertical]="true"></mat-divider>
          <a
            class="privacy-link"
            [href]="env.websiteBaseUrl + pageLabels.privacyLink.url"
            [innerHTML]="pageLabels.privacyLink.linkText"
            [attr.aria-label]="pageLabels.privacyLink.ariaLabel"
            target="_blank"
          ></a>
        </div>
      </div>
    </div>
  </div>
}
